import React, { FunctionComponent } from 'react'
import DartsWinner, { BasicDartsWinnerProps } from '..'

export type LegWinnerProps = {
    /** the double which finished the leg */
    finishingDouble: string
    /** number of thrown darts in this leg */
    numberOfThrows: number
} & BasicDartsWinnerProps

const LegWinner: FunctionComponent<LegWinnerProps> = ({
    finishingDouble,
    numberOfThrows,
    playerName,
    threeDartsAverage,
    playerImageUrl,
    playerImageAlt,
    countryImageAlt,
    countryImageUrl,
}) => (
    <DartsWinner
        winningType="Leg"
        finishingDouble={finishingDouble}
        playerName={playerName}
        threeDartsAverage={threeDartsAverage}
        numberOfThrows={numberOfThrows}
        playerImageUrl={playerImageUrl}
        playerImageAlt={playerImageAlt}
        countryImageAlt={countryImageAlt}
        countryImageUrl={countryImageUrl}
    />
)
export default LegWinner
